import { useFormStore } from '@/stores/form'
import { useGlobalStore } from '@/stores/global'
import client_lookups from '@/assets/json/clientLookups.json'
import client_config from '@/assets/json/client_config.json'
import axiosInstance from '@/services'

const initForm = async () => {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const {
    serviceTransactionId,
    serviceConfig: { hideIdentity }
  } = globalStore.startedService
  const {
    virtualResidencyServices,
    residencyBusinessServices: { years10, years5 },
    ServiceTransactions: {
      mediumTermResidenceforGraduatesforBest100UniversitiesOutsideUAE,
      shortTermResidenceforGraduatesforBest200UniversitiesOutsideUAE,
      isDivorcedOrWidowedFamilyService,
      isDivorcedOrWidowedFamilyRenew
    }
  } = client_lookups
  const { isCardReaderRequired } = client_config
  formStore.extraMap = {
    ...formStore.extraMap,
    isNewBorn: false,
    showProffessionNote: false,
    disableSponsorType: false,
    isEIDAholderSponsor: true,
    isUsingSponsorEIDA: isCardReaderRequired,
    hideIdentity
  }

  const isTrueSponsorEIDA = [
    ...virtualResidencyServices,
    isDivorcedOrWidowedFamilyService,
    isDivorcedOrWidowedFamilyRenew
  ].includes(+serviceTransactionId)

  const isFalseSponsorEIDA = [
    years10,
    years5,
    mediumTermResidenceforGraduatesforBest100UniversitiesOutsideUAE,
    shortTermResidenceforGraduatesforBest200UniversitiesOutsideUAE
  ].includes(+serviceTransactionId)

  if (isTrueSponsorEIDA) {
    formStore.extraMap.isUsingSponsorEIDA = true
  }

  if (hideIdentity || isFalseSponsorEIDA) {
    formStore.extraMap.isUsingSponsorEIDA = false
  }
}

const initData = async () => {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const { serviceTransactionId } = globalStore.startedService
  const {
    ServiceTransactions: {
      sonAbove18Service,
      unifiedFormSonAbove18Service,
      finishedStudyingInsideUAEService,
      renewResiAndEidaForStudentsStudyingOrFinishedStudying
    },
    nationality: { ukraine },
    maritalStatuses: { Single },
    educationLevels: { none },
    newBornResidency,
    uaeNationality,
    relationships: { son },
    gender: { male }
  } = client_lookups

  let currentNationalityId = null
  if (serviceTransactionId == 85) currentNationalityId = ukraine
  if (serviceTransactionId == 89) currentNationalityId = 147
  formStore.draft.request = {
    ...formStore.draft.request,
    currentNationalityId
  }
  if (
    [
      sonAbove18Service,
      unifiedFormSonAbove18Service,
      finishedStudyingInsideUAEService,
      renewResiAndEidaForStudentsStudyingOrFinishedStudying
    ].includes(serviceTransactionId)
  ) {
    formStore.draft.request = {
      sponsorRelationshipId: son,
      genderId: male
    }
  }
  if (newBornResidency.includes(serviceTransactionId)) {
    formStore.extraMap.isNewBorn = true
    formStore.draft.request = {
      ...formStore.draft.request,
      countryOfBirthId: uaeNationality,
      maritalStatusId: Single,
      educationLevelId: none
    }
  }
}

const showProfessionsNote = async () => {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const { serviceTransactionId } = globalStore.startedService
  const response = await axiosInstance.get(
    `/api/individual/chickIsFamilyMember/${serviceTransactionId}`
  )
  if (!response) return
  formStore.extraMap.showProffessionNote = result
}
export default async function () {
  try {
    await initForm()
    await initData()
    await showProfessionsNote()
  } catch (error) {
    console.error('useTypingCenterResidencyPreload', error)
  }
}
